import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrdersApiAdapter, UpdateOrderPayload } from '../adapters';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useToast } from '@shared/hooks/use-toast';
import { translateOrderApiError } from '../../CreateEditOrders/utils/errorTranslator';

export const useUpdateOrder = () => {
  const { t } = useTranslation('viewOrdersModule');
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateOrder = async (orderId: number, payload: UpdateOrderPayload) => {
    try {
      setLoading(true);
      setError(null);
      const api = new OrdersApiAdapter(createHttpClient(apiClientWH));
      await api.updateOrder(orderId, payload);
      toast({
        title: t('toasts.update-success.title'),
        description: t('toasts.update-success.description'),
        variant: 'success',
      });
      return true;
    } catch (err: any) {
      const errorMessage = translateOrderApiError(err, t);
      
      setError(errorMessage);
      toast({
        title: t('toasts.update-error.title'),
        description: errorMessage,
        variant: 'destructive',
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { updateOrder, loading, error };
};
